enum SearchType {
  CONTAINS = 'contains',
  STARTS_WITH = 'startsWith',
}

export default SearchType;
